import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { VhIconComponent } from '../icon/icon.component';
import type { VhIconName } from '../icon/vh-icons';

/**
 * Reusable empty / no-results panel. Caller provides a title, optional
 * description, an icon, and can project a CTA via <ng-content>.
 */
@Component({
  selector: 'vh-empty-state',
  standalone: true,
  imports: [VhIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="vh-empty__icon" aria-hidden="true">
      <vh-icon [name]="icon()" size="xl" [strokeWidth]="1.5" />
    </span>
    <h3 class="vh-empty__title">{{ title() }}</h3>
    @if (description()) {
      <p class="vh-empty__description">{{ description() }}</p>
    }
    <div class="vh-empty__cta">
      <ng-content />
    </div>
  `,
  styleUrl: './empty-state.component.scss',
})
export class VhEmptyStateComponent {
  readonly title = input.required<string>();
  readonly description = input<string | null>(null);
  readonly icon = input<VhIconName>('search');
}
